import { combineReducers } from 'redux'

import { reducer as threatsListReducer } from './DataAccess/'
import { reducer as threatDetailReducer } from './ThreatDetail/DataAccess'

export default combineReducers({
  detail: threatDetailReducer,
  list: threatsListReducer
})
